<template>
  <div>
    <v-text-field
      v-model="search"
      :label="$store.state.user.langEng ? 'Search file' : 'Sök fil'"
      solo
      hide-details
      clearable
      clear-icon="highlight-off"
    ></v-text-field>
    <v-treeview
      class="files-tree"
      :items="files"
      :search="search"
      :filter="filter"
      activatable
      :active.sync="active"
      hoverable
      return-object
      transition
      open-on-click
    >
      <template v-slot:prepend="{ item, open }">
        <v-icon v-if="item.children">{{ open ? 'folder_open' : 'folder' }}</v-icon>
        <v-icon v-else>insert_drive_file</v-icon>
      </template>
      <template v-slot:label="{ item }">
        <span v-if="isImageFile(item.name)">
          <p
            class="m-0"
            @mousemove="showTooltip($event, item.id)"
            @mouseleave="showTooltip($event, item.id, true)"
          >{{ fileName(item.name) }}</p>
        </span>
        <p v-else class="m-0" :title="fileName(item.name)">{{ fileName(item.name) }}</p>
      </template>
    </v-treeview>
  </div>
</template>

<script>
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { eventBus } from "@/main";
import { Api } from "@/utils";
import $ from "jquery";

@Component
export default class StoredFiles extends Vue {
  @Prop() type;
  tooltip = null;
  files = [];
  search = "";
  active = [];
  handledZipFiles = 0;

  @Watch("active")
  async handleSelected(val) {
    if (!val.length) return;

    this.$emit("selectedFilePath", val[0].id);

    if (val[0].id.includes(".zip")) {
      await this.fetchCodeListings(val[0].id);
    } else if (val[0].id.includes("/uploads/images/")) {
      this.showTooltip({}, "", true); // remove tooltip
      eventBus.$emit("addImageToMarkdown", val[0].id);
      this.$store.commit("setCurrentContentArea", "TextArea");
    } else {
      eventBus.$emit("addFileToContentArea", val[0]);
      this.$store.commit("setCurrentContentArea", "TextArea");
    }
  }

  showTooltip(e, image, remove = false) {
    let mX = e.pageX + 20;
    let mY = e.pageY + 10;
    if (remove && this.tooltip) {
      this.tooltip.remove();
      this.tooltip = null;
      return;
    }
    if (this.tooltip) {
      this.tooltip.css({
        top: mY,
        left: mX
      });
      return;
    }
    let thumb = this.getThumb(image);
    this.tooltip = $(`<img class="tooltip" src="${thumb}"/>`);
    this.tooltip
      .appendTo("body")
      .fadeIn("slow")
      .css({
        top: mY,
        left: mX
      });
  }

  fileName(name) {
    if (!/\.\w+$/.test(name) && /\dT\d/.test(name)) {
      let dateTime = name.split("T");
      dateTime[0] = dateTime[0]
        .split("-")
        .map(s => s.padStart(2, "0"))
        .join("-");

      dateTime[1] = dateTime[1]
        .split("-")
        .map(s => s.padStart(2, "0"))
        .join(":");

      const date = new Date(dateTime.join("T"));
      const result = new Intl.DateTimeFormat("sv-SE", {
        dateStyle: "medium",
        timeStyle: "short"
      })
        .format(date)
        .replace(/(\d\d:\d\d)/, "($1)");
      return result;
    } else {
      return name;
    }
  }

  getThumb(image) {
    return (
      image.substr(0, image.lastIndexOf(".")) +
      `-thumb` +
      image.substr(image.lastIndexOf("."))
    );
  }

  isImageFile(filename) {
    return filename
      .toLowerCase()
      .match(/\.(bmp|apng|gif|jpg|jpeg|jfif|pjpeg|pjp|png|svg|webp)$/);
  }

  get filter() {
    return (item, search, textKey) => item[textKey].indexOf(search) > -1;
  }

  async fetchFiles() {
    const response = await Api.get("files");
    this.files = response.files;
  }

  async fetchCodeListings(file) {
    eventBus.$emit("loadingZip", true);
    const response = await Api.get(
      `listzip/list/${file.replace("/uploads/zips", "")}`
    ).catch(() => eventBus.$emit("loadingZip", false));

    this.$emit("zipFileList", { list: response, file });
    // $on CodeFromZip.vue
    eventBus.$emit("loadingZip", false);
  }

  folder(file) {
    if (file && file.hasOwnProperty("type")) {
      return file.type === "folder" ? `?folder=${file.name}` : "";
    }
    return "";
  }

  @Watch("$store.state.article.zipFiles")
  async watchZipFiles(files) {
    if (this.handledZipFiles > files.length) {
      // Shouldn't happen but just in case.
      this.handledZipFiles = 0;
    }

    let i = this.handledZipFiles;
    this.handledZipFiles = files.length;
    const len = files.length;
    for (i; i < len; ++i) {
      await this.fetchCodeListings(files[i]);
    }
  }

  created() {
    this.fetchFiles();
    eventBus.$on("listGithubCode", github => this.fetchCodeListings(github));
  }

  beforeDestroy() {
    this.showTooltip({}, "", true)
    eventBus.$off("listGithubCode");
  }
}
</script>

<style lang="scss">
.tooltip {
  position: absolute;
  width: 150px;
  border-radius: 4px;
  z-index: 60;
}
.files-tree {
  text-align: start;
  .item-label {
    position: relative;
  }
  a {
    text-decoration: none;
    color: black;
  }
}
.file-cards {
  border-radius: 5px;

  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.v-treeview-node__children .v-treeview-node__children {
  max-height: 300px;
  overflow: auto;
}
</style>
